<template>
    <div class="">
        <install-wizard-card>
            <template #top-header>
                Alarm Activation
            </template>
            <template #top-content>
                If you're ready, go ahead and activate alarms!
            </template>

            <template #body-summary>
                <div class="flex flex-wrap ml-6">
                    <div class="w-full sm:w-3/4 mr-0 sm:mr-4">
                        Alarm Profiles are assigned to individual points.
                      {{ groupAlarmingEnabled ? 'All users who can view zones receive alarms by default' : ' You can select the users to receive any alarms notifications for a particular Zone.' }}
                    </div>
                    <a class="mt-4 sm:mt-0">
                        <span @click="saveAll" class="pb-1 text-blue-800 border-b border-blue-800 cursor-pointer">Save Progress</span>
                    </a>
                </div>
                <neutral-message v-if="isSaving > 0">Saving</neutral-message>
                <error-message v-if="errorSaving">Error deleting group. Try again later</error-message>
            </template>

            <template #body-action>
                <install-wizard-well v-for="(zone, zoneIndex) in zones" :key="zone.id">
                    <template #well-header-left>
                        <div class="mt-2 flex flex-wrap items-center text-sm leading-5 text-black-500">
                            <span class="truncate w-full text-md"> {{ zone.areaName }}</span>
                            <span class="truncate w-full text-md font-semibold">{{ zone.name }}</span>
                        </div>
                    </template>
                    <template #well-header-center>
                        <div class="mt-2 flex items-center">
                            <div    v-if="!groupAlarmingEnabled"
                                    @click.stop
                                    class="text-sm leading-5 text-gray-900 w-full">
                                <span class="text-gray-500 text-sm">Users Receiving Our Generated Alarms</span>
                                <select2
                                        :options="zone.availableUsers"
                                        v-model:value="zones[zoneIndex].users"
                                        :multiple="true">
                                </select2>
                            </div>
                            <div    v-else
                                    @click.stop
                                    class="text-sm leading-5 text-gray-900 w-full">
                                <span class="text-gray-500 text-sm">All users who can view the zone will receive alarms</span>
                            </div>
                        </div>
                    </template>
                    <template #well-content>
                        <ul class="grid grid-cols-1 gap-6 md:grid-cols-2 lg:grid-cols-2">
                            <install-wizard-alarm-activation-card
                                    @save-alarm-profile="saveProfile(meter)"
                                    v-for="(meter, meterIndex) in zone.meters"
                                    :key="meter.id"
                                    :alarm-profiles="alarmProfiles"
                                    :meter="zones[zoneIndex].meters[meterIndex]">
                            </install-wizard-alarm-activation-card>
                        </ul>
                    </template>
                </install-wizard-well>
            </template>

            <template #bottom-header>
                Done activating alarms?
            </template>
            <!--                                      TODO: WHEN THIS IS complete, you need to pull the system out of Wizard mode -->

            <template v-if="finalStep"
              #bottom-button>
                <button type="button"
                        @click="completeStep"
                        class="relative inline-flex items-center px-4 py-2 border border-transparent text-sm leading-5 font-medium rounded-md text-white bg-blue-600 hover:bg-blue-500 focus:outline-none focus:ring-blue-200 focus:border-blue-700 active:bg-blue-700 cursor-pointer">
                    <slot name="bottom-button-text">Complete and move on!</slot>
                </button>
            </template>
          <template v-else
                                 #bottom-button>
                You must complete all other steps before completing this step.
            </template>
        </install-wizard-card>
    </div>
</template>

<script>
    import axios from 'axios';
    import InstallWizardCard from "./InstallWizardCard";
    import InstallWizardAlarmActivationCard from "@/components/InstallWizard/InstallWizardAlarmActivationCard";
    import {SonicuCoreMixin} from "@/mixins/SonicuCoreMixin";

    export default {
        name: "InstallWizardAlarmActivation",
        mixins: [SonicuCoreMixin],
        components: {InstallWizardAlarmActivationCard, InstallWizardCard},
        props: {
            alarmProfiles: {
                type: Object,
                default: function() {
                    return {}
                },
            },
            zones: {
                type: Object,
                default: function() {
                    return {}
                }
            },
            users: {
                type: Object,
                default: function() {
                    return {}
                }
            },
            groupAlarmingEnabled: Boolean,
          finalStep: Boolean,
        },
        data() {
            return {
                isSaving: 0,
                errorSaving: null,
            }
        },
        methods: {
            saveProfile(meter) {
                this.isSaving++
                axios.put(this.company.buildCompanyApiInternalRoute('wizard/alarm-activation/'), {
                    type: 'save-profile',
                    meter_id: meter.id,
                    alarm_profile_id: meter.alarmProfile,
                }).then(
                    response => {
                        this.isSaving--
                        if (!response) {
                            this.errorSaving = "Could Not Save Profile.  Try Again Later."
                        }
                    }
                ).catch(
                    error => {
                        this.errorSaving = error
                    }
                )
            },
            saveZone(zone) {
                this.isSaving++
                axios.put(this.company.buildCompanyApiInternalRoute('wizard/alarm-activation/'), {
                    type: 'save-users',
                    zone_id: zone.id,
                    users: zone.users,
                }).then(
                    response => {
                        this.isSaving--
                    }
                ).catch(
                    error => {
                        this.errorSaving = error
                        console.log(error)
                    }
                )

                zone.meters.forEach((item, key) => {
                    this.saveProfile(item)
                })
            },
            saveAll() {
                Object.values(this.zones).forEach((item) => {
                    this.saveZone(item)
                })
            },
            completeStep() {
                this.saveAll()
                axios.post(this.targetRoute, {}).then(function (response) {
                    window.location.href = response.data.target;
                    return true;
                })
            }
        },
        computed: {
            targetRoute: function () {
                if (this.specialRoute) {
                    return this.specialRoute;
                } else {
                    return window.location.pathname;
                }
            }
        }
    }
</script>

<style scoped>

</style>